export default __webpack_public_path__ + "static/media/error-illustration.a6ee616e.svg";